import styled from 'styled-components'

export const ContainerContent = styled.div`
  width: 80%;
  margin-top: 4rem;
  display: flex;
  justify-content: center;
  .MuiAccordion-root {
    background-color: inherit;
    color: #fff;
  }
`
export const Container = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
`
export const H1 = styled.h1`
  margin-bottom: 5rem;
`
